import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-stone-100 px-5 py-20 sm:py-28" data-id="element-18" data-mp="pjzlbb82zkbs">
      <div className="mx-auto max-w-2xl" data-id="element-19" data-mp="pj6c83lngiqh">
        <h2 className="text-center text-[1.6rem] font-black leading-tight tracking-tight text-stone-900 sm:text-[2.2rem]" data-id="element-20" data-mp="avd0itzoq0d6">
          <span aria-hidden="true" data-id="element-21" data-mp="ft4q3hcuxae7">🎁 </span>5 Exclusive Bonuses
        </h2>
        <p className="mt-2 text-center text-sm text-stone-600" data-id="element-22" data-mp="1tvl7du3q2pj">
          Valued at{' '}
          <span className="font-bold text-amber-600 line-through" data-id="element-23" data-mp="5vqlcf0aqa1q">
            $87 USD
          </span>{' '}
          — Included <span className="font-bold text-red-500" data-id="element-24" data-mp="3o2eow0fp6p5a">FREE</span>
        </p>

        <ol className="mt-9 space-y-4" data-id="element-25" data-mp="3t0ohc3a1fbn7">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex items-center gap-4 rounded-2xl bg-white p-4 shadow-sm" data-id="element-26" data-mp="3t2slmmbumco0" data-mpi={index}>
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-red-500 text-sm font-bold text-white" data-id="element-27" data-mp="1m85qbz8x0eql">
                {index + 1}
              </span>
              <img src={bonus.cover} alt="" className="h-28 w-[84px] shrink-0 rounded-lg object-cover shadow-md sm:h-36 sm:w-28" data-id="element-28" data-mp="3iclo5tyzymyv" />
              <div data-id="element-29" data-mp="3r6qhck1lsahk">
                <h3 className="text-sm font-bold leading-snug text-stone-900 sm:text-base" data-id="element-30" data-mp="3r79tfk4ko4no">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-[11px] font-bold" data-id="element-31" data-mp="3n5y83qsqe5la">
                  <span className="text-amber-600 line-through" data-id="element-32" data-mp="2zeskuqkgob0y">
                    was {bonus.was}
                  </span>{' '}
                  <span className="text-red-500" data-id="element-33" data-mp="2ui26q8s7vpi6">FREE</span>
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}